/** The editor route: `/projects/:projectId/models/:modelId`. */
const EDITOR_ROUTE = /^\/projects\/[^/]+\/models\/([^/]+)\/?$/

/** The model id the current URL says is open, or null off the editor. */
export function editorModelIdFromPath(pathname: string): string | null {
  return EDITOR_ROUTE.exec(pathname)?.[1] ?? null
}

/**
 * Whether the model sitting in the store is genuinely the one open on screen.
 *
 * The store is the wrong thing to ask on its own. `clearModel()` exists in the
 * model store and documents itself as the navigate-away path, but **nothing in
 * the application calls it** — only tests do. A model therefore stays resident
 * long after the user has left the editor.
 *
 * Reading the store alone would attach that stale model to a bundle sent from
 * the dashboard: the checkbox would appear, pre-checked, offering to include
 * "your open model" when no model is open. That is customer engineering IP
 * leaving on a consent the user was never really given.
 *
 * So the URL is the authority for *whether* a model is open, and the store only
 * supplies its contents. Both must agree on which model, because between two
 * editor routes the store can still hold the previous one while the URL already
 * names the next.
 */
export function isModelOpenHere(pathname: string, storeModelId: string | null): boolean {
  if (storeModelId === null) return false
  return editorModelIdFromPath(pathname) === storeModelId
}
